<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="
            tableAcl.indexOf('Push') != -1 &&
            !system_setting.isAutoSubmitOrderToPriceMonitor
          " type="primary" class="btn primary" @click="push">确认上传</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed :reserve-selection="true" prop="selection" type="selection" width="55"
          align="center"></el-table-column>
        <el-table-column fixed type="index" width="55" align="center" label="序号"></el-table-column>
        <el-table-column prop="priceMonitorHospitalId" width="150" label="医院编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseOrderNo" width="150" label="院采购单号" show-overflow-tooltip></el-table-column>

        <el-table-column prop="distributeId" width="220" label="平台配送明细编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderDetailId" width="220" label="平台订单明细编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierProductNo" width="180" show-overflow-tooltip label="院目录编码"></el-table-column>
        <el-table-column prop="supplierProductName" width="120" label="院产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName" width="120" label="院规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerName" width="120" label="院生产厂家" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="procurecatalogId" width="100" label="平台商品Id" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="goodsId" width="100" label="平台产品Id" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="unit" width="80" label="单位" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="purchasePrice" width="80" label="采购价格" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseNumber" width="80" label="采购数量"></el-table-column>
        <el-table-column prop="distributeCount" width="80" label="配送数量" show-overflow-tooltip></el-table-column>
        <el-table-column prop="warehouseCount" width="80" label="收货数量" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="returnCount" width="80" label="退货数量" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="spdInStockCount" width="120" label="耗材入库数量" show-overflow-tooltip></el-table-column>
        <el-table-column prop="spdOutStockCount" width="120" label="耗材退货数量"></el-table-column>
        <el-table-column prop="batchCode" width="120" label="批号"></el-table-column>
        <el-table-column prop="periodDate" label="有效期" width="120">
          <template slot-scope="scope">
            {{
              scope.row.periodDate
                ? parseTime(new Date(scope.row.periodDate), "{y}-{m}-{d}")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="companyIdPs" width="120" label="配送企业编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNamePs" width="120" label="配送企业名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="distributeTime" width="170" label="配送时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.distributeTime))
            }}</template>
        </el-table-column>
        <el-table-column prop="warehouseTime" width="170" label="入库时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.warehouseTime))
            }}</template>
        </el-table-column>
        <el-table-column prop="distributeCustomInfo" width="150" label="配送备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="hospitalOrderDetailId" width="150" label="院采购单明细编号"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="invoiceId" width="110" label="发票号序列号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="invoiceCode" width="140" label="发票代码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="invoiceNo" width="110" show-overflow-tooltip label="发票号"></el-table-column>
        <el-table-column prop="invoiceValidStateName" width="130" label="发票验证状态"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="invoiceValidRemark" width="140" label="发票验证备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailDistributeAddress" width="120" label="配送地点"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyIdTb" width="120" label="投标企业ID" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyNameTb" width="120" label="投标企业名称" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetDistributes } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import { WhetherOptions, ProcurecatalogTypeOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetDistributes,
      WhetherOptions: WhetherOptions,
      ProcurecatalogTypeOptions: ProcurecatalogTypeOptions,
      filterOptions: [
        // {
        //   name: "平台产品ID",
        //   type: "input",
        //   code: "procurecatalogId"
        // },
        {
          name: "平台产品ID",
          type: "input",
          code: "goodsId",
        },
        // {
        //   name: "单位",
        //   type: "input",
        //   code: "unit"
        // },
        {
          name: "院目录编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "院产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "院规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "院生产厂家",
          type: "input",
          code: "manufacturerName",
        },
        {
          name: "平台配送企业编码",
          type: "input",
          code: "companyIdPs",
        },
        {
          name: "配送企业名称",
          type: "input",
          code: "companyNamePs",
        },
        {
          name: "平台订单明细编号",
          type: "input",
          code: "orderDetailId",
        },
        {
          name: "批号",
          type: "input",
          code: "batchCode",
        },
        {
          name: "有效期",
          type: "date",
          code: "periodDate",
          startDateCode: "periodDateStart",
          endDateCode: "periodDateEnd",
        },
        {
          name: "配送时间",
          type: "date",
          code: "distributeTime",
          // startDateCode: "startDate",
          // endDateCode: 'endDate'
        },
        {
          name: "收货时间",
          type: "date",
          code: "warehouseTime",
          // startDateCode: "warehouseTimeStart",
          // endDateCode: 'warehouseTimeEnd'
        },
        {
          name: "发票号",
          type: "input",
          code: "invoiceId",
        },
      ],
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
    };
  },
  methods: {
    // 获取列表
    getData() {
      this.loading = true;
      this.GetDatasAction(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;

          // this.getSpanArr(this.tableData)
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }

      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    // getDefaultDateRange () {
    //   var endDate = new Date()
    //   var start = new Date(new Date().setDate(new Date().getDate() - 6))
    //   // 开始日期转换为00:00:00
    //   var startDate = new Date(`${start.getFullYear()}-${start.getMonth()}-${start.getDate()} 00:00:00`)

    //   return [startDate, endDate]
    // },
  },
  mounted() {
    this.getData();
  },
  created() {
    // var dateArr = this.getDefaultDateRange();
    // this.query.startDate = this.parseTime(dateArr[0])
    // this.query.endDate = this.parseTime(dateArr[1])
  },
};
</script>

<style lang="scss" scoped></style>
